
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 3000 3000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-earth",attrs:{"stroke":"#F6FBE5","stroke-width":"43","d":"M1459.13 1415.9a93.56 93.56 0 0 1 60.58-7.3 93.54 93.54 0 0 1 52.18 31.61"}}),_c('path',{staticClass:"i-venus",attrs:{"stroke":"#94CC3F","stroke-dasharray":"1 7","d":"M1602.67 1461.86c9.97 26.85 9.03 56.55-2.63 82.71a109.48 109.48 0 0 1-59.74 57.27"}}),_c('g',{staticClass:"i-comet clockwise fast",attrs:{"stroke":"#F9CE62"}},[_c('path',{staticClass:"i-Ellipse 653",attrs:{"d":"M1596.9 1257.3a262.3 262.3 0 0 1 104.11 76.71 262.4 262.4 0 0 1 54.85 117.11"}}),_c('circle',{staticClass:"i-Ellipse 655",attrs:{"cx":"1756.5","cy":"1457.11","r":"5.5","transform":"rotate(-10.836 1756.5 1457.11)"}})]),_c('path',{staticClass:"i-mercury counterclockwise fast",attrs:{"stroke":"#D1ED7E","stroke-dasharray":"7 7","d":"M1417.46 1518.1a84.7 84.7 0 0 1-.51-33.71 84.6 84.6 0 0 1 12.72-31.23 84.4 84.4 0 0 1 23.91-23.76 84.3 84.3 0 0 1 31.29-12.53 84.3 84.3 0 0 1 33.71.7 84.4 84.4 0 0 1 30.75 13.82c9.21 6.63 17 15.04 22.89 24.75 5.9 9.7 9.77 20.49 11.4 31.72"}})])
          )
        }
      }
    